import { createReducer } from '@reduxjs/toolkit';
import { PreviewShape } from './model';
import * as previewActions from './actions';

const initialState: PreviewShape = {
  inProgress: {},
  modal: {
    assetId: undefined,
    open: false,
  },
};

export const previewReducer = createReducer<PreviewShape>(initialState, (builder) =>
  builder
    .addCase(previewActions.setInProgress, (state, action) => {
      if (action.payload.inProgress) {
        state.inProgress[action.payload.assetId] = true;
      } else {
        delete state.inProgress[action.payload.assetId];
      }
    })
    .addCase(previewActions.setModal, (state, action) => {
      if (action.payload.open) {
        state.modal.assetId = action.payload.assetId;
        state.modal.open = true;
      } else {
        state.modal.assetId = undefined;
        state.modal.open = false;
      }
    }),
);
